module.exports = __webpack_public_path__ + "img/6.6cb40c3c.jpg";